<script>

import countryList from 'country-list';
import usStatesData from 'datasets-us-states-abbr-names';
import USPS from 'usps-webtools';

import ENV from '@/ENV'

export default {
	name: 'AddressSection',
	props: ['currentAddress', 'firstTabIndex' ],
	components: {
	},
	data () {
		return {
			tabIndex: parseInt( this.firstTabIndex || 0 ),
			countries: [],
			states: usStatesData,
			addressVerified: null,
			countryName: this.currentAddress.country || 'United States',
			country: this.currentAddress.countryCode || 'us',
			state: this.currentAddress.state || '',
			city: this.currentAddress.city || '',
			street: this.currentAddress.street || '',
			zip: this.currentAddress.zip || '',
			zip4: this.currentAddress.zip4 || '',
		}
	},
	watch: {
		country (country) {
			if( country == 'us' )
				this.states = usStatesData;
			else
				this.states = false;
			this.countryName = this.countries[ country ];
			this.$emit('update', 'country', this.countryName);
		},
		state(v){
			this.$emit('update', 'state', v);
		},
		city(v){
			this.$emit('update', 'city', v);
		},
		street(v){
			this.$emit('update', 'street', v);
		},
		zip(v){
			this.$emit('update', 'zip', v);
		},
		zip4(v){
			this.$emit('update', 'zip4', v);
		},
	},
	computed: {

	},
	methods: {
		getCityStateByZip (){
			if( 
				! this.zip 
				|| this.zip.length < 5
				|| this.country != 'us' 
			) {
				return;
			}
			this.usps.cityStateLookup(this.zip, (error, resp) => {
				this.city = resp.city;
				this.state = resp.state;
			});
		},
		verifyAddress () {
			if( 
				! this.street
				||
				this.zip == ''
				||
				this.state == ''
				||
				this.country != 'us' 
			) {
				this.addressVerified = null;
				return;
			}
			var street = this.street.split("\n");

			let toVerify = {
				street1: street[0],
				city: this.city,
				state: this.state,
				zip: this.zip
			}
			if( street.length > 1 ){
				street.shift();
				toVerify.street2 = street.join("\n")
			}
			this.usps.verify(toVerify, (err,resp) => {
				// if address is not found, err is populated
				if( err != null ){
					this.addressVerified = false;
					this.$emit('address-not-verified');
					this.zip4 = '';
					return;
				}

				this.addressVerified = true;
				this.zip4 = resp.zip4;
				this.$emit('verified-address');
			})
		}
	},
	created () {
		this.countries = countryList.getCodeList();
		this.usps = new USPS({
			server: 'http://production.shippingapis.com/ShippingAPI.dll',
			userId: ENV.USPS_userId,
			ttl: 5000,
		});
	},
	mounted () {
		if( this.firstTabIndex )
			this.tabIndex = parseInt(this.firstTabIndex);
		else 
			this.tabIndex = 0;
	},
}
</script>


<template>
	<div>
		<label class="block" for="sender-zip">Zip Code</label>
		<input 
			type="text" 
			id="sender-zip" 
			name="sender-zip" 
			autocomplete="off" 
			minlength="5" 
			v-model="zip" 
			@keyup="getCityStateByZip" 
			class="inline"
			:tabindex="tabIndex"
			>
		<input 
			type="text" disabled 
			autocomplete="off" min-
			length="4" 
			max-length="4" 
			v-model="zip4" 
			class="inline zip4" 
			placeholder="0000"
			:tabindex="tabIndex+1"
			>

		<label class="block req">Address</label>
		<textarea 
			autocomplete="off" 
			required 
			v-model="street" 
			@blur="verifyAddress"
			:class="{'error': addressVerified===false}"
			:tabindex="tabIndex+2"
		></textarea>

		<label class="block req" for="sender-city">City</label>
		<input 
			type="text" 
			value="Lewiston" 
			autocomplete="off" 
			required 
			v-model="city"
			:tabindex="tabIndex+3"
			>

		<label class="block req" for="sender-country">Country</label>
		<select autocomplete="off" v-model="country" :tabindex="tabIndex+4">
			<option v-for="(country,code) in countries" :value="code" :key="code">{{ country }}</option>
		</select>

		<label class="block" for="sender-state" v-if="states">State</label>
		<select autocomplete="off" v-model="state" v-if="states" :tabindex="tabIndex+5">
			<option v-for="(state,code) in states" :value="code" :key="code">{{ state }}</option>
		</select>
	</div>
</template>


<style scoped lang="scss">
.inline {
	display: inline;
	width: auto;
}
.zip4 {
	width: 5em;
	margin-left: 5px;
}
input[disabled] {
	opacity: .7;
}
</style>